import { ClassDetailsNoSectionsQuery } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { PageWidthSection } from "@outschool/ui-legacy-component-library";
import { SystemStyleObject } from "@styled-system/css";
import React from "react";

import { usePageVisitHistoryList } from "../hooks/usePageVisitHistoryList";
import ListingCarousel from "./ListingCarousel";

export default function VisitHistoryListingsCarousel({
  currentActivity,
  carouselRowNum,
  headingSx,
  leftAlign,
}: {
  currentActivity?: ClassDetailsNoSectionsQuery["activity"];
  carouselRowNum: number;
  headingSx?: SystemStyleObject;
  leftAlign?: boolean;
}) {
  const listings = usePageVisitHistoryList(currentActivity);

  const { t } = useTranslation(
    "ui-components-website\\src\\Listings\\Carousels\\VisitHistoryListingsCarousel"
  );

  if (!listings) {
    return null;
  }

  return (
    <PageWidthSection>
      <ListingCarousel
        title={t`Recently viewed`}
        trackingLabel={"listing_card"}
        trackingProperties={{
          carousel_type: "visit_history",
        }}
        carouselRowNum={carouselRowNum}
        listings={listings}
        sx={{
          padding: 0,
        }}
        headingSx={headingSx}
        leftAlign={leftAlign}
      />
    </PageWidthSection>
  );
}
